import { render, staticRenderFns } from "./Attainment.vue?vue&type=template&id=fa936452"
import script from "./Attainment.vue?vue&type=script&lang=js"
export * from "./Attainment.vue?vue&type=script&lang=js"
import style0 from "./Attainment.vue?vue&type=style&index=0&id=fa936452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports